import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useSearchParams } from "react-router-dom"
import { SUCCESS } from "constants/index"
import { updateUserProfile } from "appRedux/slices/userSlice"
import { useAppSelector } from "appRedux/hooks"
import PaymentResult from "components/organisms/PaymentResult"

export default function PaymentResultPage() {
  const userProfile = useAppSelector((state) => state.user.profile)

  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()

  const resultStatus = searchParams.get("status") || ""
  const reference = searchParams.get("reference") || ""

  useEffect(() => {
    if (resultStatus.toLowerCase() === SUCCESS) {
      if (!userProfile) return
      dispatch(updateUserProfile({
        ...userProfile,
        isPremium: true
      }))
    }
  }, [resultStatus])

  return (
    <PaymentResult
      status={resultStatus as PaymentResultStatus}
      reference={reference}
    />
  )
}
